export  const ScrollToTopButton = () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })}
